var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.hideHeader
        ? _c(
            "h3",
            [_c("plain-text-control", { attrs: { title: _vm.title } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: _vm.resourceSourcePath + ".Postal",
          id: "postaladdress",
          maxLength: 100,
          rows: 1,
          hideCharsLeft: true,
          required: _vm.isInvestmentReport
        },
        model: {
          value: _vm.item.address,
          callback: function($$v) {
            _vm.$set(_vm.item, "address", $$v)
          },
          expression: "item.address"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: _vm.resourceSourcePath + ".PostalCode",
          id: "postalcode",
          textColWidth: "col-3",
          rows: 1,
          hideCharsLeft: true,
          maxLength: 5,
          rules: _vm.postalCodeRules,
          required: _vm.isInvestmentReport
        },
        model: {
          value: _vm.item.postalCode,
          callback: function($$v) {
            _vm.$set(_vm.item, "postalCode", $$v)
          },
          expression: "item.postalCode"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: _vm.resourceSourcePath + ".City",
          options: _vm.municipalities,
          dropdownId: "city",
          required: true,
          doNotUseResources: true,
          optionOutput: true,
          value:
            _vm.item.city.length > 0
              ? _vm.item.city[0]
              : { name: null, id: null }
        },
        on: {
          input: function($event) {
            _vm.item.city = $event.name
              ? [{ name: $event.name, id: $event.id }]
              : []
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }